module.exports = __webpack_public_path__ + "a745d39ddddd343e9875a61d597bdcf7.png";